<template>

        <b-nav-item 
            v-if="!hidden_route"
            :to="{name: route.name}" 
            link-classes="d-flex align-items-center justify-content-between">{{name}} <font-awesome-icon :icon="['far', 'arrow-right']" />
        </b-nav-item>

</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "menu-item",
    props: {
        route: {
            type: Object
        }
    },
    computed: {
        ...mapGetters('auth', ['loggedIn','isActivity', 'isMemberAdmin']),
        hidden_route() {
            if (this.route.meta.hidden) {
                return true;
            }

            if (this.route.name == 'admin' && !this.isActivity && !this.isMemberAdmin) {
                return true;
            }

            if (this.route.name == 'my-profile' && !this.loggedIn) {
                return true;
            }

            if (this.route.name == 'login' && this.loggedIn) {
                return true;
            }

            return false;
        },
        name() {
            return this.route.meta.title;
            // return this.route.name
            //     .toLowerCase()
            //     .split("-")
            //     .map(s => s.charAt(0).toUpperCase() + s.slice(1))
            //     .join(" ");
        }
    },
    mounted() {
        // console.log(this.route);
    }
}
</script>